import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/storybook-components/dist/Box'
import { Text } from '@node-space/storybook-components/dist/Text'
import { TransactionDetailRow } from 'components/TransactionDetails/TransactionDetailRow'

type Currency = {
  code: string
  name: string
}

interface SidePanelBodyProps {
  transactionDetails: {
    currency: Currency
    amount: string
    type: string
    status: string
    uuid: string
  }
}

export const SidePanelBody = ({ transactionDetails }: SidePanelBodyProps) => {
  const { t } = useTranslation()

  return (
    <Box padding={16}>
      <Text size="base" weight="medium" color="dark-grey">
        {t('transactionDetails')}
      </Text>
      <Box paddingT={8} paddingB={8}>
        <TransactionDetailRow
          label={t('approvals.amountWithdrawn')}
          detail={`${transactionDetails?.amount} ${transactionDetails?.currency?.code}`}
        />
      </Box>
    </Box>
  )
}
